import { TranslateService } from "@ngx-translate/core";
import { Component, OnInit, OnDestroy } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { GestionContextService } from "../../context/getion-context.service";
import { GestionService } from "../../services/gestion.service";
import { DataProvider } from "projects/packcert-web/src/app/providers/data.provider";
import { SessionContextService } from "projects/packcert-web/src/app/context/session-context.service";
import { Message, SpinnerService, UtilsService } from "shared-components";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-mantenimiento-productos",
  templateUrl: "./mantenimiento-productos.component.html",
})
export class MantenimientoProductosComponent implements OnInit, OnDestroy {
  private readonly _DEFAULT_ITEMS_PER_PAGE = 10;

  private _filters;
  public filtersVisible = false;
  public filtersForm: UntypedFormGroup;
  public dropdownInfo: number;

  public productos;
  public producto;

  public mensajes = new Array<Message>();
  public showError: boolean;
  public showErrorWarning: boolean;

  public deleteModal = false;
  public newEditModal = false;
  public translateModal = false;

  public itemsPerPage = this._DEFAULT_ITEMS_PER_PAGE;
  public currentPage = 0;
  public totalItems: number;
  public readonly visiblePages = 3;

  public toEditId;
  private toDeleteId;
  private toTranslateId;

  public pestanaActiva = new Array<number>();

  public nombreComponente;
  public dropdownSection: number;

  private readonly destroy$ = new Subject<void>();

  constructor(
    private _fb: UntypedFormBuilder,
    private _spinnerService: SpinnerService,
    private readonly _sessionContext: SessionContextService,
    private _gestionContextService: GestionContextService,
    private _gestionService: GestionService,
    private _dataProvider: DataProvider,
    private utilsService: UtilsService,
    private readonly _translate: TranslateService
  ) {}

  ngOnInit() {
    this.nombreComponente = "MantenimientoProductosComponent";
    this.filtersForm = this._fb.group({
      desProductoDefecto: [""],
      fechaInicio: [""],
      fechaFin: [""],
      dateType: ["false"],
    });

    this._gestionContextService.mantenimientoProductosFilters = null;

    this.getProductos();

    this.filtersForm
      .get("fechaInicio")
      .valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe(() => this.validDates());
    this.filtersForm
      .get("fechaFin")
      .valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe(() => this.validDates());
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public get defaultLanguage() {
    return this._translate.getDefaultLang();
  }

  public get isSmallScreen() {
    return this._sessionContext.isSmallScreen();
  }

  public validDates() {
    if (
      this.filtersForm.get("fechaInicio").value &&
      this.filtersForm.get("fechaFin").value
    ) {
      if (
        this.checkDates(
          this.filtersForm.get("fechaInicio").value,
          this.filtersForm.get("fechaFin").value
        )
      ) {
        this.clearDatesValidators();
      } else {
        this.filtersForm.get("fechaInicio").setErrors(["Invalid date"]);
        this.filtersForm.get("fechaFin").setErrors(["Invalid date"]);
      }
      if (
        this.filtersForm.get("fechaInicio").invalid ||
        this.filtersForm.get("fechaFin").invalid
      ) {
        this.showError = true;
        this.mensajes.push({
          class: "error",
          message: "global.fecha.error.finAnteriorInicio",
        });
      } else {
        this.showError = false;
        this.mensajes = [];
      }
    } else {
      this.clearDatesValidators();
      this.showError = false;
      this.mensajes = [];
    }
  }

  private clearDatesValidators() {
    if (
      this.filtersForm.get("fechaFin").errors &&
      this.filtersForm.get("fechaFin").errors.includes("Invalid date")
    ) {
      this.filtersForm.get("fechaFin").clearValidators();
      this.filtersForm.get("fechaFin").updateValueAndValidity();
    }
    if (
      this.filtersForm.get("fechaInicio").errors &&
      this.filtersForm.get("fechaInicio").errors.includes("Invalid date")
    ) {
      this.filtersForm.get("fechaInicio").clearValidators();
      this.filtersForm.get("fechaInicio").updateValueAndValidity();
    }
  }

  private checkDates(inicio, fin) {
    const inicioD = new Date(inicio);
    const finD = new Date(fin);
    return inicioD <= finD;
  }

  public pageChange(page) {
    this.dropdownSection = -1;
    this._gestionContextService.mantenimientoProductosFilters.numPagina =
      this.currentPage = page - 1;
    this.getProductos();
  }

  public itemsPerPageChange(items) {
    this.dropdownSection = -1;
    this._gestionContextService.mantenimientoProductosFilters.numPagina =
      this.currentPage = 0;
    this._gestionContextService.mantenimientoProductosFilters.tamPagina =
      this.itemsPerPage = items;
    this.getProductos();
  }

  public checkValuesForm(): boolean {
    return this.filtersForm.get("fechaInicio").value ||
      this.filtersForm.get("fechaFin").value ||
      this.filtersForm.get("desProductoDefecto").value
      ? true
      : false;
  }

  public filtrar() {
    this.validDates();
    if (this.filtersForm.valid) {
      this.applyFilters();
    }
  }

  public resetForm() {
    this.filtersForm.reset();
    this.filtersForm.get("dateType").patchValue("false");
  }

  public applyFilters() {
    this.currentPage = 0;
    this._gestionContextService.mantenimientoProductosFilters = {
      desProductoDefecto: this.filtersForm.get("desProductoDefecto").value
        ? this.filtersForm.get("desProductoDefecto").value
        : "",
      fechaInicio: this.filtersForm.get("fechaInicio").value
        ? this.utilsService.parseGMTtoYYYYMMDD(
            this.filtersForm.get("fechaInicio").value
          )
        : "",
      fechaFin: this.filtersForm.get("fechaFin").value
        ? this.utilsService.parseGMTtoYYYYMMDD(
            this.filtersForm.get("fechaFin").value
          )
        : "",
      fechaActualizacion: this.filtersForm.get("dateType").value,
      numPagina: this.currentPage,
      tamPagina: this.itemsPerPage,
    };
    this.getProductos();
  }

  public getProductos() {
    if (this._gestionContextService.mantenimientoProductosFilters) {
      this._filters = this._gestionContextService.mantenimientoProductosFilters;
    } else {
      this.applyFilters();
    }
    this._spinnerService.showSpinner();
    this._gestionService
      .getProductos(this._filters)
      .toPromise()
      .finally(() => {
        this._spinnerService.hideSpinner();
      })
      .then((resp) => {
        this.totalItems = resp.paginacionMeta.totalCount;
        this.productos = resp.lista;
      }, (error) => {
        this.showError = true;
        this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
      });
  }

  public create() {
    this.toEditId = null;
    this.newEditModal = true;
  }

  public update(producto) {
    this.toEditId = producto.id;
    this.newEditModal = true;
  }

  public translate(producto) {
    this.toTranslateId = producto.id;

    this._gestionService.getProducto(this.toTranslateId).subscribe((resp) => {
      this.producto = resp.desProductoDefecto;
    });
    this.translateModal = true;
  }

  public delete() {
    this._spinnerService.showSpinner();
    this._gestionService
      .deleteProducto(this.toDeleteId)
      .toPromise()
      .finally(() => {
        this._spinnerService.hideSpinner();
      })
      .then(() => {
        this.close();
        this.pushMessage("global.success.itemDeleted");
        this._dataProvider.refreshProductos();
        this.getProductos();
      });
  }

  public askDelete(producto) {
    this.toDeleteId = producto.id;
    this.deleteModal = true;
  }

  public close() {
    this.deleteModal = false;
    this.newEditModal = false;
    this.translateModal = false;
  }

  public refresh(value) {
    this.newEditModal = false;
    this.translateModal = false;
    if (value) {
      this.getProductos();
    }
  }

  public pushMessage(mensaje) {
    this.showError = true;
    this.mensajes.push({ class: "success", message: mensaje });
  }

  public showSection(i, producto) {
    this.toTranslateId = producto.id;
    this.dropdownSection = this.dropdownSection === i ? -1 : i;
    this.pestanaActiva[i] =
      this.pestanaActiva[i] > 0 ? this.pestanaActiva[i] : 1;
  }

  public toRefresh(value) {
    this.getProductos();
  }

  public trackByProductoId(index: number, producto: { id: number }): number {
    return producto.id;
  }
}
